import React from 'react';
import { CustomSelect } from 'components';
import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import useMeasurementDateListOptions
  from 'pages/Waterfall/components/MeasurementDateList/useMeasurementDateListOptions';

const MeasurementDateList = (props: CustomSelectProps) => {
  const { cell, onCommit, onRevert } = props;

  const {options} = useMeasurementDateListOptions()

  return (
    <CustomSelect
      id="measurement-date-list"
      options={options}
      value={cell.value as string}
      onCommit={onCommit}
      onRevert={onRevert}
      onEmptyValue=""
      menuPlacement="bottom"
      usePortal
    />)
}

export default MeasurementDateList;